import { BooleanFilterOperationType } from 'components/organisms/tasks/filters/boolean';
import { DateFieldFilterOperationType } from 'components/organisms/tasks/filters/date';
import { NumberFilterOperationType } from 'components/organisms/tasks/filters/number';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { TextFieldFilterOperationType } from 'components/organisms/tasks/filters/text';
import { unreachable } from 'utils/unreachable';

export enum OperationType {
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  Value = 'value',
  Contains = 'contains',
  IsNull = 'isNull',
  OneOf = 'oneOf',
}

export enum Operation {
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  Value = 'value',
  IsNot = 'isNot',
  HasValue = 'hasValue',
  Contains = 'contains',
  NotContains = 'notContains',
  IsNull = 'isNull',
  OneOf = 'oneOf',
  NoneOf = 'noneOf',
}

export enum NumberOperationType {
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
  Value = 'value',
}

export type FilterOperationType =
  | NumberFilterOperationType
  | SelectFilterOperationType
  | BooleanFilterOperationType
  | TextFieldFilterOperationType
  | DateFieldFilterOperationType;

export const fromOperation = (type: Operation): FilterOperationType => {
  switch (type) {
    case Operation.Contains:
      return TextFieldFilterOperationType.Contains;
    default:
      return unreachable(type as never);
  }
};
